import { ORDER_STATUSES, USER_ROLES, ORDER_DETAILS_MODE } from "./constants";

const distributorFields = [
    {
        title: "_distributor_cooperation_type_",
        key: "distributorCooperationType",
        showInTable: false,
        canChange: {
            type: "distributorCooperationType",
        },
    },
    {
        title: "_username_",
        key: "username",
        isKey: true,
        dataSort: true,
        isRequired: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_email_",
        key: "email",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_email_soft_pos_",
        key: "softPosEmail",
        isRequired: false,
        canChange: {
            type: "text",
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
            },
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_legal_email_address_",
        key: "legalEmailAddress",
        isRequired: false,
        canChange: {
            type: "text",
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
            },
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_individual_entrepreneur_name_",
        key: "individualEntrepreneurName",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        showInTable: false,
    },
    {
        title: "_taxpayer_identification_number_",
        key: "taxpayerIdentificationNumber",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        showInTable: false,
    },
    {
        title: "_taxpayer_charging_amount_",
        key: "taxPayerChargingAmount",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
    {
        title: "_contract_date_",
        key: "contractDate",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "date",
        },
        showInTable: false,
    },
    {
        title: "_tariff_",
        key: "tariff",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "tariff",
        },
        showInTable: true,
    },
    {
        title: "_area_",
        key: "area",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "area",
        },
        isRequired: false,
        isDisabled: false,
        showInTable: true,
    },
    {
        title: "_available_debt_",
        key: "availableDebt",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "availableDebt",
        },
        showInTable: true,
    },
    // {
    //     title: "remove ",
    //     key: "receivableLimit",
    //     isKey: false,
    //     dataSort: true,
    //     canChange: {
    //         type: "number",
    //         validations: {
    //             receivableLimit: true,
    //         },
    //         validationErrors: {
    //             receivableLimit: "_receivables_limit_range_error_",
    //         },
    //     },
    //     isRequired: false,
    //     showInTable: true,
    // },
    {
        title: "_tip_share_",
        key: "tipShare",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "number",
            validations: {
                tipShare: true,
            },
            validationErrors: {
                tipShare: "_tip_share__limit_range_error_",
            },
        },
        isRequired: false,
        showInTable: true,
    },
    // {
    //     title: "_effective_date_",
    //     key: "effectiveDate",
    //     isKey: false,
    //     dataSort: false,
    //     canChange: {
    //         type: "date",
    //     },
    //     showInTable: false,
    // },
    {
        title: "_distribution_partner_",
        key: "distributionPartner",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "distributionPartner",
        },
        showInTable: false,
    },
    // {
    //     title: "_company_tin_",
    //     key: "companyTin",
    //     isKey: false,
    //     dataSort: true,
    //     canChange: {
    //         type: "selectCompany",
    //     },
    //     isRequired: true,
    //     isDisabled: true,
    //     showInTable: true,
    // },
    {
        title: "_terminal_id_",
        key: "terminalId",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
            validations: {
                matchRegexp: /^((?!(0))[0-9]{6})$/,
            },
            validationErrors: {
                matchRegexp: "_terminalId_min_max_error_",
            },
        },
        isRequired: false,
        isDisabled: true,
        showInTable: false,
    },
    {
        title: "_distributor_phone_",
        key: "phone",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
            validations: {
                minLength: 9,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_phone_min_max_error_",
                maxLength: "_phone_min_max_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_is_hzor_",
        key: "isHzorUser",
        canChange: {
            type: "checkbox",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_distributor_address_",
        key: "address",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "Իրավաբանական անձի հասցե",
        key: "legalAddress",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "Հարկման ռեժիմ",
        key: "taxRegime",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "taxRegime",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "ՀԴՄ գրանցման համարը (CRN)",
        key: "crn",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "ՀԴՄ գործարանային համար (SN)",
        key: "sn",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "text",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "ՀԴՄ բաժնի համար",
        key: "dep",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "number",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "Գանձապահի համար",
        key: "cashierId",
        isKey: false,
        dataSort: false,
        canChange: {
            type: "number",
        },
        isRequired: false,
        showInTable: false,
    },
    {
        title: "_is_online_",
        key: "isOnline",
        isKey: false,
        dataSort: true,
        canChange: false,
        showInTable: true,
    },
    {
        title: "_status_",
        key: "status",
        isKey: false,
        dataSort: true,
        canChange: false,
        showInTable: true,
    },
    {
        title: "_partner_debt_",
        key: "payableAmount",
        isKey: false,
        dataSort: true,
        canChange: false,
        showInTable: false,
    },
    {
        title: "_password_",
        key: "password",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                minLength: 8,
                maxLength: 64,
                matchRegexp:
                    /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,64}$/,
            },
            validationErrors: {
                minLength: "_password_min_max_error_",
                maxLength: "_password_min_max_error_",
                matchRegexp: "_password_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_confirm_password_",
        key: "confirmPassword",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                passwordMatch: true,
            },
            validationErrors: {
                passwordMatch: "_password_match_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_fund_deposit_",
        key: "fundDeposit",
        canChange: {
            type: "checkbox",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_charging_amount_",
        key: "chargingAmount",
        isRequired: false,
        isKey: false,
        dataSort: true,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
    {
        title: "_charging_balance_",
        key: "chargingBalance",
        isRequired: false,
        canChange: {
            type: "number",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_pos_terminal_id_",
        key: "posTerminalId",
        isKey: false,
        dataSort: true,
        isRequired: false,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
    {
        title: "_terminal_type_",
        key: "posTerminalType",
        showInTable: false,
        canChange: {
            type: "terminalType",
        },
    },
    {
        title: "_pos_provided_date_",
        key: "posProvidedDate",
        isRequired: false,
        canChange: {
            type: "date",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_bag_",
        key: "bag",
        isRequired: false,
        canChange: {
            type: "text",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_bag_provided_date_",
        key: "bagProvidedDate",
        isRequired: false,
        canChange: {
            type: "date",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_provided_transport_",
        key: "providedTransport",
        isRequired: false,
        canChange: {
            type: "string",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_transport_provided_date_",
        key: "transportProvidedDate",
        isRequired: false,
        canChange: {
            type: "date",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_salary_fund_deposit_",
        key: "salaryFundDeposit",
        canChange: {
            type: "checkbox",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_salary_charging_amount_",
        key: "salaryChargingAmount",
        isRequired: false,
        isKey: false,
        dataSort: true,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
    {
        title: "_salary_charging_balance_",
        key: "salaryChargingBalance",
        isRequired: false,
        canChange: {
            type: "number",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_save_deposit_",
        key: "saveDeposit",
        canChange: {
            type: "checkbox",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_save_deposit_amount_",
        key: "saveDepositAmount",
        isRequired: false,
        isKey: false,
        dataSort: true,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
    {
        title: "_save_deposit_total_",
        key: "saveDepositTotal",
        isRequired: false,
        isKey: false,
        dataSort: true,
        canChange: {
            type: "number",
        },
        showInTable: false,
    },
];

const portalUserFields = [
    {
        title: "_username_",
        key: "username",
        isKey: true,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_email_",
        key: "email",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_password_",
        key: "password",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                minLength: 8,
                maxLength: 64,
                matchRegexp:
                    /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,64}$/,
            },
            validationErrors: {
                minLength: "_password_min_max_error_",
                maxLength: "_password_min_max_error_",
                matchRegexp: "_password_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_confirm_password_",
        key: "confirmPassword",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                passwordMatch: true,
            },
            validationErrors: {
                passwordMatch: "_password_match_error_",
            },
        },
        showInTable: false,
    },
];

const apiUserFields = [
    {
        title: "_username_",
        key: "username",
        isKey: true,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_access_token_",
        key: "accessToken",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "accessToken",
        },
        showInTable: false,
    },
    {
        title: "_access_list_",
        key: "accessList",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "accessList",
        },
        showInTable: false,
    },
];

const distributionPartnerFields = [
    {
        title: "_username_",
        key: "username",
        isKey: true,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_base_url_",
        key: "baseUrl",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validationErrors: {
                isUrl: "_invalid_url_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_create_request_",
        key: "createOrder",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "request",
        },
        showInTable: false,
    },
    {
        title: "_update_request_",
        key: "updateOrder",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "request",
        },
        showInTable: false,
    },
    {
        title: "_cancel_request_",
        key: "cancelOrder",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "request",
        },
        showInTable: false,
    },
    {
        title: "_get_status_request_",
        key: "getStatus",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "request",
        },
        showInTable: false,
    },
    {
        title: "_password_",
        key: "password",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                minLength: 8,
                maxLength: 64,
                matchRegexp:
                    /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,64}$/,
            },
            validationErrors: {
                minLength: "_password_min_max_error_",
                maxLength: "_password_min_max_error_",
                matchRegexp: "_password_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_confirm_password_",
        key: "confirmPassword",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                passwordMatch: true,
            },
            validationErrors: {
                passwordMatch: "_password_match_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_api_user_",
        key: "apiUser",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "apiUser",
        },
        showInTable: false,
    },
    {
        title: "_username_in_partner_system_",
        key: "authUserName",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_password_in_partner_system_",
        key: "authPassword",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                minLength: 8,
                maxLength: 64,
                matchRegexp:
                    /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,64}$/,
            },
            validationErrors: {
                minLength: "_password_min_max_error_",
                maxLength: "_password_min_max_error_",
                matchRegexp: "_password_error_",
            },
        },
        showInTable: false,
    },
];

const b2bUserFields = [
    {
        title: "_tin_",
        key: "tin",
        isKey: true,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 8,
                maxLength: 8,
            },
            validationErrors: {
                minLength: "_tin_min_max_error_",
                maxLength: "_tin_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_address_",
        key: "address",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
        },
        showInTable: false,
    },
    {
        title: "_email_",
        key: "email",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                isEmail: true,
                minLength: 6,
                maxLength: 64,
            },
            validationErrors: {
                isEmail: "_email_format_error_",
                minLength: "_email_min_max_error_",
                maxLength: "_email_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_phone_",
        key: "phone",
        canChange: {
            type: "text",
            validations: {
                minLength: 9,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_phone_min_max_error_",
                maxLength: "_phone_min_max_error_",
            },
        },
        showInTable: true,
    },
];

const supplierUserFields = [
    {
        title: "_username_",
        key: "username",
        isKey: true,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 5,
                maxLength: 25,
            },
            validationErrors: {
                minLength: "_username_min_max_error_",
                maxLength: "_username_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_user_type_",
        key: "userType",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "userType",
            validations: {
                isRequired: false,
            },
            validationErrors: {
                isRequired: "Պարտադիր դաշտ",
            },
        },
        showInTable: true,
    },
    {
        title: "_partner_",
        key: "partner",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "partner",
        },
        showInTable: true,
    },
    {
        title: "_branch_",
        key: "branch",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "branch",
        },
        showInTable: true,
    },
    {
        title: "_all_branches_",
        key: "isCallCenter",
        canChange: {
            type: "branch_call_center",
        },
        isKey: false,
        dataSort: true,
        showInTable: false,
    },
    {
        title: "_extra_partner_",
        key: "extra",
        canChange: {
            type: "extra",
        },
        isKey: false,
        dataSort: false,
        showInTable: false,
    },
    // {
    //     title: '_extra_branch_',
    //     key: 'extraBranch',
    //     canChange: {
    //         type: 'branch',
    //     },
    //     isKey: false,
    //     dataSort: true,
    //     showInTable: false
    // },
    {
        title: "_name_",
        key: "name",
        isKey: false,
        dataSort: true,
        canChange: {
            type: "text",
            validations: {
                minLength: 2,
                maxLength: 64,
            },
            validationErrors: {
                minLength: "_name_min_max_error_",
                maxLength: "_name_min_max_error_",
            },
        },
        showInTable: true,
    },
    {
        title: "_password_",
        key: "password",
        isKey: false,
        dataSort: false,
        canChange: {
            isPassword: true,
            type: "password",
            validations: {
                minLength: 8,
                maxLength: 64,
                matchRegexp:
                    /^(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[A-Za-z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,64}$/,
            },
            validationErrors: {
                minLength: "_password_min_max_error_",
                maxLength: "_password_min_max_error_",
                matchRegexp: "_password_error_",
            },
        },
        showInTable: false,
    },
    {
        title: "_temporary_password_",
        key: "temporaryPassword",
        isKey: false,
        dataSort: false,
        isRequired: false,
        canChange: {
            isPassword: true,
            type: "temporaryPassword",
        },
        showInTable: false,
    },
    // {
    //     title: "_confirm_password_",
    //     key: "confirmPassword",
    //     isKey: false,
    //     dataSort: false,
    //     canChange: {
    //         isPassword: true,
    //         type: "password",
    //         validations: {
    //             passwordMatch: true,
    //         },
    //         validationErrors: {
    //             passwordMatch: "_password_match_error_",
    //         },
    //     },
    //     showInTable: false,
    // },
];

const distributorTypes = [
    {
        title: "_car_",
        isDefault: true,
        checked: true,
        id: 1,
    },
    {
        title: "_moto_bike_",
        isDefault: false,
        checked: true,
        id: 2,
    },
    {
        title: "_bike_",
        isDefault: false,
        checked: true,
        id: 3,
    },
    {
        title: "_scooter_",
        isDefault: false,
        checked: true,
        id: 4,
    },
    {
        title: "_pedestrian_",
        isDefault: false,
        checked: true,
        id: 5,
    },
];

export const voucherDetailsTableColumns = [
    {
        title: "_voucher_code_",
        key: "code",
        isKey: true,
        dataSort: false,
        thStyle: {
            minWidth: "120px",
            width: "120px",
        },
        width: "120px",
    },
    {
        title: "_description_",
        key: "description",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "150px",
            width: "150px",
        },
        width: "150px",
    },
    {
        title: "_total_amount_",
        key: "totalAmount",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_buyam_amount_",
        key: "buyAmAmount",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_supplier_amount_",
        key: "supplierAmount",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_third_party_amount_",
        key: "thirdPartAmount",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "120px",
            width: "120px",
        },
        width: "120px",
    },
];

export const orderPaymentDetailsTableColumns = [
    {
        title: "_receiver_name_",
        key: "userName",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "120px",
        },
        width: "120px",
    },
    {
        title: "_customer_id_",
        key: "userId",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_payment_transaction_id_",
        key: "transactionId",
        isKey: true,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_payment_type_",
        key: "paymentType",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_paid_amount_",
        key: "invoiceAmount",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_applied_bonus_campain_amount_",
        key: "appliedBonus",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },
    {
        title: "_discount_campain_code_",
        key: "discountCode",
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: "100px",
            width: "100px",
        },
        width: "100px",
    },

    // OMSNEW-144: temporarily commented till business will finalize and backend will finish implementation
    /*
    {
        title: '_order_amount_',
        key: 'orderAmount',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_calculated_delivery_price_',
        key: 'calculatedDeliveryPrice',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_applied_delivery_price_',
        key: 'appliedDeliveryPrice',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_delivery_campain_id_',
        key: 'deliveryCampainId',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_delivery_price_',
        key: 'deliveryPrice',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_partner_name_',
        key: 'partnerName',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_order_final_amount',
        key: 'serviceFee.total',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    {
        title: '_payment_refund_amount_',
        key: 'paymentRefundAmount',
        isKey: false,
        dataSort: false,
        thStyle: {
            minWidth: '100px',
            width: '100px'
        },
        width: '100px'
    },
    */
];

export default {
    order: {
        view: {
            table: {
                [USER_ROLES.MANAGER]: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    // {
                    //     title: "_transaction_id_",
                    //     key: "transactionId",
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "110px",
                    //         width: "110px",
                    //     },
                    //     width: "110px",
                    // },
                    {
                        title: "_operator_",
                        key: "operator",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: true,
                        isNested: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    // {
                    //     title: "_receiver_phone_",
                    //     key: "receiver.phone",
                    //     isNested: false,
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "100px",
                    //         width: "100px",
                    //     },
                    //     width: "100px",
                    // },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        isNested: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "50px",
                            width: "50px",
                        },
                        width: "50px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "50px",
                            width: "50px",
                        },
                        width: "50px",
                    },
                    {
                        title: "_reason_type_",
                        key: "ticket.source[0].reason",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "170px",
                            width: "170px",
                        },
                        width: "170px",
                    },
                    {
                        title: "_status_",
                        key: "status",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_supplier_status_",
                        key: "supplierStatus",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                [USER_ROLES.ADMIN]: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_call_id_",
                        key: "ticket.source.0.source.content",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_operator_",
                        key: "ticket.creator",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: true,
                        isNested: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    // {
                    //     title: "_receiver_phone_",
                    //     key: "receiver.phone",
                    //     isNested: false,
                    //     isKey: false,
                    //     dataSort: true,
                    // },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                    },
                    // {
                    //     title: "_locations_",
                    //     key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                    //     isNested: true,
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "100px",
                    //         width: "100px",
                    //     },
                    //     width: "100px",
                    // },
                    // {
                    //     title: "_shop_region",
                    //     key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                    //     isNested: true,
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "100px",
                    //         width: "100px",
                    //     },
                    //     width: "100px",
                    // },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_order_content_",
                        isNested: true,
                        key: "shops.0.products.0.name",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    {
                        title: "_status_",
                        key: "status",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_source_",
                        key: "source",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                [USER_ROLES.ORDER_MANAGER]: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "60px",
                            width: "60px",
                        },
                        width: "60px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    // {
                    //     title: '_can_replace_products_',
                    //     key: 'canReplaceProducts',
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: '90px',
                    //         width: '90px'
                    //     },
                    //     width: '90px'
                    // },
                    {
                        title: "_source_",
                        key: "source",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: true,
                        isNested: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_receiver_phone_",
                        key: "receiver.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    // {
                    //     title: "_locations_",
                    //     key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                    //     isNested: true,
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "100px",
                    //         width: "100px",
                    //     },
                    //     width: "100px",
                    // },
                    // {
                    //     title: "_shop_region",
                    //     key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                    //     isNested: true,
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: "100px",
                    //         width: "100px",
                    //     },
                    //     width: "100px",
                    // },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        isNested: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "50px",
                            width: "50px",
                        },
                        width: "50px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_reason_type_",
                        key: "ticket.source[0].reason",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    // {
                    //     title: '_status_',
                    //     key: 'status',
                    //     isKey: false,
                    //     dataSort: true,
                    //     thStyle: {
                    //         minWidth: '90px',
                    //         width: '90px'
                    //     },
                    //     width: '90px'
                    // },
                    {
                        title: "_operator_",
                        key: "operator",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_supplier_status_",
                        key: "supplierStatus",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                [USER_ROLES.CALL_CENTER]: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_call_id_",
                        key: "ticket.source.0.source.content",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_operator_",
                        key: "ticket.creator",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: true,
                        isNested: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "70px",
                            width: "70px",
                        },
                        width: "70px",
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_discount_code_",
                        key: "discountCode",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_delivery_code_",
                        key: "deliveryCode",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    {
                        title: "_status_",
                        key: "status",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_supplier_status_",
                        key: "supplierStatus",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                [USER_ROLES.SUPER_ADMIN]: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_call_id_",
                        key: "ticket.source.0.source.content",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_operator_",
                        key: "operator",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: true,
                        isNested: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_receiver_phone_",
                        key: "receiver.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "170px",
                            width: "170px",
                        },
                        width: "170px",
                    },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_order_content_",
                        isNested: true,
                        key: "shops.0.products.0.name",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    {
                        title: "_status_",
                        key: "status",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_source_",
                        key: "source",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                delivered_orders: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: false,
                        isNested: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_in_place_time_",
                        key: "inPlaceTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_receiver_phone_",
                        key: "receiver.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },

                    {
                        title: "_partner_type_",
                        key: "shops.restaurantInfo.type",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_hint_",
                        key: "hint",
                        isDate: false,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_bonus_",
                        key: "bonusAmount",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_reason_type_",
                        key: "ticket.source[0].reason",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    {
                        title: "_source_",
                        key: "source",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
                canceled_orders: [
                    {
                        title: "_eta_",
                        key: "eta",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_order_id_",
                        key: "orderId",
                        isKey: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_transaction_id_",
                        key: "transactionId",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_order_date_time_",
                        key: "createdTime",
                        isDate: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_delivery_date_time_",
                        key: "deliveryTime",
                        isDate: false,
                        isKey: false,
                        dataSort: false,
                        isNested: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_customer_name_",
                        key: "customer.name",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_customer_phone_",
                        key: "customer.phone",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_address_",
                        key: "receiver.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_shop_",
                        key: "shopName",
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_locations_",
                        key: "shops.0.restaurantInfo.restaurantInformation.location.address",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    }, {
                        title: "_shop_region",
                        key: "shops.0.restaurantInfo.restaurantInformation.regionName",
                        isNested: true,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_ready_time_",
                        key: "readyTime",
                        isDate: true,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_hint_",
                        key: "hint",
                        isDate: false,
                        isNested: false,
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "100px",
                            width: "100px",
                        },
                        width: "100px",
                    },
                    {
                        title: "_total_amount_",
                        key: "price",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_bonus_",
                        key: "bonusAmount",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "80px",
                            width: "80px",
                        },
                        width: "80px",
                    },
                    {
                        title: "_payment_method_",
                        key: "paymentType",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "110px",
                            width: "110px",
                        },
                        width: "110px",
                    },
                    {
                        title: "_comments_",
                        key: "comments",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_delivery_price_label_",
                        key: "deliveryPrice",
                        isKey: false,
                        dataSort: true,
                    },
                    {
                        title: "_distributor_",
                        key: "distributor",
                        isKey: false,
                        dataSort: false,
                        thStyle: {
                            minWidth: "130px",
                            width: "130px",
                        },
                        width: "130px",
                    },
                    {
                        title: "_source_",
                        key: "source",
                        isKey: false,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_cancel_reason_",
                        key: "cancelReason.reason",
                        isKey: false,
                        isNested: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                    {
                        title: "_cancel_time_",
                        key: "cancelReason.cancelTime",
                        isKey: false,
                        isNested: true,
                        isDate: true,
                        dataSort: true,
                        thStyle: {
                            minWidth: "90px",
                            width: "90px",
                        },
                        width: "90px",
                    },
                ],
            },
        },
        edit: {
            [USER_ROLES.MANAGER]: [
                "hint",
                "distributor",
                // "deliveryPrice",
                "save",
                "paymentType",
                "notes",
            ],
            [USER_ROLES.CALL_CENTER]: [],
            [USER_ROLES.ORDER_MANAGER]: [
                "customer",
                "shops",
                "deliveryPrice",
                "cacheIn",
                "canReplaceProducts",
                "isChangesAccepted",
                "cooperationType",
                "status",
                "hint",
                "orderCancel",
                "address",
                "additionalAddress",
                "deliveryTime",
                "receiverPhone",
                "paymentType",
                "additionalPaymentType",
                "exportOrder",
                "giftCardCodes",
                "giftCardAmount",
                "bonusAmount",
                "save",
                "notes",
                "isSplitOrder",
                "sendToEmail",
                "messageToRecipient",
            ],
            [USER_ROLES.ADMIN]: [],
            [USER_ROLES.SUPER_ADMIN]: [
                "customer",
                "shops",
                "deliveryPrice",
                "cacheIn",
                "canReplaceProducts",
                "isChangesAccepted",
                "cooperationType",
                "status",
                "hint",
                "orderCancel",
                "address",
                "additionalAddress",
                "deliveryTime",
                "receiverPhone",
                "paymentType",
                "additionalPaymentType",
                "distributor",
                "giftCardCodes",
                "giftCardAmount",
                "bonusAmount",
                "save",
                "imTaxCode",
                "notes",
                "additionalCashAmount",
            ],
            [USER_ROLES.ACCOUNTANT]: ["customer", "imTaxCode", "save"],
        },
        canEdit(role, orderStatus, mode, field) {
            const fields = this.edit[role] || [];

            if (field && -1 === fields.indexOf(field)) {
                return false;
            }

            const isCanceled = orderStatus === ORDER_STATUSES.CANCELED.statusId;

            if ((isCanceled && mode === ORDER_DETAILS_MODE.MODES.cancel_mode) ||
                (!isCanceled && mode === ORDER_DETAILS_MODE.MODES.restore_mode)) {
                return false;
            }

            if (role === USER_ROLES.SUPER_ADMIN) {
                return true;
            }

            if ([USER_ROLES.ADMIN, USER_ROLES.CALL_CENTER].includes(role)) {
                return false;
            }

            if (role === USER_ROLES.ORDER_MANAGER && orderStatus === ORDER_STATUSES.VERIFIED.statusId) {
                return false;
            }

            if (orderStatus === ORDER_STATUSES.DELIVERED.statusId && role !== USER_ROLES.SUPER_ADMIN && field === "save") {
                return false;
            }

            if (role === USER_ROLES.ORDER_MANAGER && orderStatus === ORDER_STATUSES.DELIVERED.statusId &&
                mode !== ORDER_DETAILS_MODE.MODES.cancel_mode &&
                (!field ||
                    field === "shops" ||
                    field === "save" ||
                    field === "customer")
            ) {
                return true;
            }

            if (role === USER_ROLES.MANAGER && mode === ORDER_DETAILS_MODE.MODES.cancel_mode) {
                return false;
            }

            if (
                role === USER_ROLES.ACCOUNTANT &&
                orderStatus === ORDER_STATUSES.DELIVERED.statusId &&
                mode !== ORDER_DETAILS_MODE.MODES.cancel_mode &&
                (!field || this.edit[role].includes(field))
            ) {
                return true;
            }

            return !(orderStatus === ORDER_STATUSES.DELIVERED.statusId ||
                orderStatus === ORDER_STATUSES.CANCELED.statusId);
        },
        canCancelAssignment(role, orderStatus) {
            if (role === USER_ROLES.SUPER_ADMIN) {
                return true;
            }

            return (
                orderStatus === ORDER_STATUSES.ASSIGNED.statusId ||
                orderStatus === ORDER_STATUSES.DRAFT.statusId ||
                orderStatus === ORDER_STATUSES.ACCEPTED.statusId
            );
        },
    },
    ticket: {
        view: {
            [USER_ROLES.ADMIN]: [
                {
                    title: "_id_",
                    key: "_id",
                    isKey: true,
                    dataSort: false,
                    hidden: true,
                },
                {
                    title: "_operator_",
                    key: "creator",
                    isKey: false,
                    dataSort: false,
                    thStyle: {
                        minWidth: "200px",
                        width: "200px",
                    },
                    width: "200px",
                },
                {
                    title: "_note_",
                    key: "note",
                    isKey: false,
                    dataSort: false,
                },
                {
                    title: "_created_date_",
                    key: "createdDate",
                    isKey: false,
                    dataSort: false,
                    thStyle: {
                        minWidth: "250px",
                        width: "250px",
                    },
                    width: "250px",
                },
            ],
            [USER_ROLES.SUPER_ADMIN]: [
                {
                    title: "_id_",
                    key: "_id",
                    isKey: true,
                    dataSort: false,
                    hidden: true,
                },
                {
                    title: "_operator_",
                    key: "creator",
                    isKey: false,
                    dataSort: false,
                    thStyle: {
                        minWidth: "200px",
                        width: "200px",
                    },
                    width: "200px",
                },
                {
                    title: "_note_",
                    key: "note",
                    isKey: false,
                    dataSort: false,
                },
                {
                    title: "_created_date_",
                    key: "createdDate",
                    isKey: false,
                    dataSort: false,
                    thStyle: {
                        minWidth: "250px",
                        width: "250px",
                    },
                    width: "250px",
                },
            ],
        },
    },
    route: {
        [USER_ROLES.MANAGER]: {
            home: "/orders/active",
        },
        [USER_ROLES.CALL_CENTER]: {
            home: "/orders/callCenter",
        },
        [USER_ROLES.ORDER_MANAGER]: {
            home: "/orders/active",
        },
        [USER_ROLES.ADMIN]: {
            home: "/orders",
        },
        [USER_ROLES.ACCOUNTANT]: {
            home: "/orders",
        },
        [USER_ROLES.PARTNER_MANAGER]: {
            home: "/orders",
        },
        [USER_ROLES.SUPER_ADMIN]: {
            home: "/orders",
        },
    },
    user: {
        getByRole(role) {
            switch (role) {
                case USER_ROLES.DISTRIBUTOR:
                    return distributorFields;
                case USER_ROLES.ADMIN:
                case USER_ROLES.MANAGER:
                case USER_ROLES.CALL_CENTER:
                case USER_ROLES.ORDER_MANAGER:
                case USER_ROLES.ACCOUNTANT:
                case USER_ROLES.PARTNER_MANAGER:
                case USER_ROLES.SUPER_ADMIN:
                    return portalUserFields;
                case USER_ROLES.SUPPLIER:
                    return supplierUserFields;
                case USER_ROLES.API_USER:
                    return apiUserFields;
                case USER_ROLES.DISTRIBUTION_PARTNER:
                    return distributionPartnerFields;
                case USER_ROLES.B2B_USER:
                    return b2bUserFields;
                default:
                    return [];
            }
        },
        getTypes(role) {
            switch (role) {
                case USER_ROLES.DISTRIBUTOR:
                    return distributorTypes;
                default:
                    return [];
            }
        },
    },
};
